export class KeysValueConverter {
    toView(obj) {
        return obj ? Reflect.ownKeys(obj) : null;
    }
}